import api from './api'

/**
 * 從儲值記錄 API 彙整曾出現過的儲值活動名稱（schemeKey），大致依記錄時間由新到舊去重。
 * @param {string} businessId
 * @param {{ pageSize?: number }} [options]
 * @returns {Promise<string[]>}
 */
export async function fetchPastTopupSchemeKeys (businessId, options = {}) {
  const { pageSize = 400 } = options
  if (!businessId) return []
  try {
    const { data } = await api.get(
      `/api/businesses/${businessId}/value-added-records`,
      {
        params: {
          page: 1,
          pageSize,
          sortField: 'bookingDate',
          sortOrder: 'descend'
        }
      }
    )
    if (data?.success === false) return []
    const recordsData = data.data?.records || data.records || []
    const ordered = []
    const seen = new Set()
    for (const record of recordsData) {
      const key = String(record.schemeKey ?? '').trim()
      if (!key || seen.has(key)) continue
      seen.add(key)
      ordered.push(key)
    }
    return ordered
  } catch (e) {
    console.error('fetchPastTopupSchemeKeys:', e)
    return []
  }
}

/**
 * 合併選項：先額外鍵（例如目前各儲值活動餘額分桶），再接歷史 API 結果，去重。
 * @param {string[]} apiKeys
 * @param {string[]} extraKeys
 * @returns {string[]}
 */
export function mergeTopupSchemeKeyOptions (apiKeys = [], extraKeys = []) {
  const seen = new Set()
  const out = []
  for (const k of [...extraKeys, ...apiKeys]) {
    const key = String(k ?? '').trim()
    if (!key || seen.has(key)) continue
    seen.add(key)
    out.push(key)
  }
  return out
}
